<div class="container-block">


  <ng-container *ngIf="!isViewAll">
    <div class="item" style="display: flex; justify-content: space-between; gap: 5px; align-items: center;">
      <p *ngIf="!objectChoosing.isActive">{{'thiet_ke_khung_khi_chua_kich_hoat' | translate}}</p>
      <p *ngIf="objectChoosing.isActive">{{'thiet_ke_khung_khi_kich_hoat' | translate}}</p>
      <nz-switch class="ml-3" [(ngModel)]="objectChoosing.isActive"
        (ngModelChange)="vhEventMediator.notifyOnConfigChanged({ _id: this.objectChoosing._id, changeActive: true });"></nz-switch>
    </div>
    <app-position-in-config [elementChoosing]="objectChoosing" [device]="device"></app-position-in-config>

    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['frame-mobile-tabs']['width']" [height]="class['frame-mobile-tabs']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu [nzTitle]="'thong_so_co_ban' | translate" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <!-- Lựa chọn {{'hien_thi' | translate}} cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Chọn option nền cho frame blank -->
          <app-background-image-config [config]="config" [class]="class"
            [backgroundClass]="objectChoosing.isActive ? class['+frame-blank'] : class['-frame-blank']"
            [backgroundConfig]="config['frame-blank']" [isBlock]="false" [id_object]="objectChoosing._id"
            [device]="device">
          </app-background-image-config>

          <!-- Vị trí khi cuộn trang -->
          <div class="mt-5 mb-3">
            <div class="title mb-2">{{'vi_tri_khi_cuon_trang' | translate}}</div>
            <nz-select [(ngModel)]="config['position_onscroll']['type']" (ngModelChange)="updateConfig()">
              <nz-option [nzValue]="0" [nzLabel]="'binh_thuong' | translate"></nz-option>
              <nz-option [nzValue]="1" [nzLabel]="'co_dinh_o_top' | translate"></nz-option>
            </nz-select>
            <div *ngIf="config['position_onscroll']['type'] != '0'" class="mt-4">
              <div class="title mb-1">{{'canh_le' | translate}}</div>
              <div class="config-name mt-0">
                <p>{{'tren' | translate}}</p>
                <nz-input-number [nzMin]="-100" [nzMax]="1000" [(ngModel)]="config['position_onscroll']['top']"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình {{'duong_vien_chung' | translate}} -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
          [borderClass]="objectChoosing.isActive ? class['+frame-blank'] : class['-frame-blank']"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút {{'mo_rong' | translate}} -->
        <div class="item-border" style="float: right;">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <!-- <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMenu.menu3" (nzOpenChange)="openHandler('menu3')">
        Đổ bóng
        <div class="slide-bar mx-1 my-3">
          <p class="m-0 title">Áp dụng</p>
          <nz-switch [(ngModel)]="config['box-shadow']['shadow_check']"
            (ngModelChange)="onChangeShadow(); updateConfig()"></nz-switch>
        </div>
        <div class="item mx-1 my-3">
          <div class="shadow-direction ">
            <div class="dir-x">
              <div class="slide-bar">
                <span>Trục X</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [(ngModel)]="config['box-shadow']['offset_x']" (ngModelChange)="onChangeShadow()"
                  (nzBlur)=" updateObject()" [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
              </div>
              <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_x']"
                (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
            </div>
            <div class="dir-y">
              <div class="slide-bar">
                <span>Trục Y</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                  [(ngModel)]="config['box-shadow']['offset_y']" (ngModelChange)="onChangeShadow()"
                  (nzBlur)="updateObject()" [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
              </div>
              <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_y']"
                (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
            </div>
            <div class="dir-b">
              <div class="slide-bar">
                <span style="line-height: 1.5">Làm mờ</span>
                <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{ width: '40%' }"
                  [(ngModel)]="config['box-shadow']['blur_radius']" (ngModelChange)="onChangeShadow()"
                  (nzBlur)="updateObject()" [disabled]="!config['box-shadow']['shadow_check']"></nz-input-number>
              </div>
              <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['blur_radius']"
                (ngModelChange)="onChangeShadow()" (nzOnAfterChange)="updateObject()"
                [nzDisabled]="!config['box-shadow']['shadow_check']"></nz-slider>
            </div>

            <div class="slide-bar">
              <p class="m-0 title w-50">Màu bóng</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="config['box-shadow']['shadow_color']"
                style="height:30px" [style.background]="config['box-shadow']['shadow_color']"
                (colorPickerClose)="onChangeShadow();updateObject()" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true" [disabled]="!config['box-shadow']['shadow_check']" />
            </div>
          </div>
        </div>
      </li> -->
      <!-- Cấu hình {{'hieu_ung' | translate}} -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="objectChoosing.isActive ? class['+frame-blank'] : class['-frame-blank']"
          [effect_hover]="effect_hover" [customize]="customize" [type]="'object'">
        </app-choose-animations-config>
      </li>

      <li *ngIf="!objectChoosing.dynamic_data" nz-submenu [nzTitle]="'lien_ket' | translate"
        (nzOpenChange)="openHandler('menu5')">
        <div class="connect-page">
          <nz-select [(ngModel)]="staticdata.link" (ngModelChange)="updateStaticData()"
            [nzPlaceHolder]="'chon_lien_ket' | translate" allowClear
            [disabled]="staticdata.hyper_link == '' || staticdata.hyper_link == null ? false : true">
            <nz-option [nzValue]="null" [nzLabel]="'lien_ket_toi_website' | translate"></nz-option>
            <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link"
            [nzLabel]="page['name_' + functionService.selectedLanguageCode] ?? page.name"></nz-option>
          </nz-select>
        </div>
        <div class="connect-link" [ngClass]="staticdata.link == null ? 'showLink' : 'hideLink'">
          <nz-input-group [nzSuffix]="suffixIconClose">
            <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="staticdata.hyper_link"
              (blur)="updateStaticData()" />
          </nz-input-group>
          <ng-template #suffixIconClose>
            <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink()"></span>
          </ng-template>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="objectChoosing.isActive ? class['+frame-blank'] : class['-frame-blank']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
    <!-- Cấu hình chi tiết {{'hieu_ung' | translate}} -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata"
        [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
    </div>
  </div>
</div>